import React from 'react'
import CreditRequestsCard from 'components/Mobile/WorkListView/CreditRequestCard'
import { useWorkListViewMnStore } from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'

const CreditRequestsTab = () => {
  const { workListViewStore } = useWorkListViewMnStore()

  return (
    <div
      style={{
        padding: 16,
        dispplay: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      {workListViewStore?.creditList?.map((item, index) => (
        <CreditRequestsCard creditRequest={item} key={index} />
      ))}
    </div>
  )
}
export default CreditRequestsTab
